import { Routes } from "../common/routes/routes";
import { validationMessages } from "../constants";

const hostname = window.location.host;
const protocol = window.location.protocol;

export const API = 'api';
export const ID_SITE = 'idSite';
export const PIX = 'pix';
export const SEARCH_SERVICE = 'searchServer';
export const AUTH = 'auth';
export const SERVICE_GATEWAY = 'serviceGateway';
export const BROKER_METRICS_API = 'brokerMetricsApi';
export const LWA_PLATFORM = 'lwaPlatform';
export const PROFILE_SERVICE = 'profileService';
export const PLATFORM_DOMAIN = 'platformDomain';
export const TALENT = 'talent';
export const LOCAL_LAUNCH = 'localLaunch';
export const PLATFORM_LOCAL_LAUNCH = 'platformLocalLaunch';
export const PLATFORM_LOCAL_LAUNCH_URL = `${protocol}//${hostname}${Routes.AUTH.BASE}`

export const isLocal = (hostname.toLowerCase().indexOf('localhost') > -1)
    || (hostname.toLowerCase().indexOf('local') > -1);
export const isDev = hostname.toLowerCase().indexOf('dev') >= 0;
export const isStaging = hostname.toLowerCase().indexOf('stg') >= 0;
export const isPre = hostname.toLowerCase().indexOf('pre') >= 0;
export const isProd = !isDev && !isStaging && !isPre && !isLocal;

export const envNames = {
    DEV: 'DEV',
    STG: 'STG',
    PRE: 'PRE',
    PROD: 'PROD',
};

const getRunningEnv = () => {
    const envs = [
        { check: isDev, name: envNames.DEV },
        { check: isStaging, name: envNames.STG },
        { check: isPre, name: envNames.PRE },
        { check: isProd, name: envNames.PROD }
    ];

    const env = envs.find(env => env.check);
    if (!env) {
        console.error(validationMessages.notValidEnvForHost);
        return;
    }
    return env.name;
};

export const runningEnv = getRunningEnv();

const buildHost = (service, env, domain) => `https://${service}${env}${domain}`;

const serviceHosts = {
    ID_SITE: (env) => buildHost('xbm-id', env, 'terradatum.com'),
    SERVICE_GATEWAY: (env) => buildHost('service-gateway', env, 'terradatum.com'),
    BROKER_METRICS_API: (env) => buildHost('brokermetrics.api', env, 'lwolf.com'),
    LWA_PLATFORM: (env) => buildHost('platform', env, 'lwolf.com'),
    PROFILE_SERVICE: (env) => buildHost('profile-service', env, 'terradatum.com'),
    PLATFORM_DOMAIN: (env) => `${env}lwolf.com`,
    TALENT: (env) => buildHost('talent', env, 'lwolf.com'),
};

const commonEndpoints = {
    [API]: `${location.protocol}//api.${location.host.substring(location.host.indexOf('.') + 1)}`,
    [PIX]: `${location.protocol}//td-images-admin.${location.host.substring(location.host.indexOf('.') + 1)}`,
    [SEARCH_SERVICE]: `${location.protocol}//aergo-search-server.${location.host.substring(location.host.indexOf('.') + 1)}`,
    [AUTH]: `${location.protocol}//td-auth.${location.host.substring(location.host.indexOf('.') + 1)}`,
}

const generateEndpoints = (env, platformEnv = env) => {
    const validEnvs = [
        'dev.',
        'stage.',
        'stg.',
        'pre.',
        '',
    ];
    const isValidEnv = validEnvs.includes(env);
    const isValidPlatformEnv = validEnvs.includes(platformEnv);

    if (!isValidEnv || !isValidPlatformEnv) {
        throw new Error(validationMessages.validEnvs);
    }

    return ({
    ...commonEndpoints,
    [ID_SITE]: serviceHosts.ID_SITE(`${!isProd ? `.${env}` : '.'}`),
    [SERVICE_GATEWAY]: serviceHosts.SERVICE_GATEWAY(`${!isProd ? `.${env}` : '.'}`),
    [BROKER_METRICS_API]: serviceHosts.BROKER_METRICS_API(`${!isProd ? `.${platformEnv}` : '.'}`),
    [LWA_PLATFORM]: serviceHosts.LWA_PLATFORM(`${!isProd ? `.${platformEnv}` : '.'}`),
    [PROFILE_SERVICE]: serviceHosts.PROFILE_SERVICE(`${!isProd ? `.${env}` : '.'}`),
    [PLATFORM_DOMAIN]: serviceHosts.PLATFORM_DOMAIN(`${!isProd ? `${platformEnv}` : ''}`),
    [TALENT]: serviceHosts.TALENT(`${!isProd ? `.${platformEnv}` : '.'}`),
    [LOCAL_LAUNCH]: isLocal ? `&lu=${PLATFORM_LOCAL_LAUNCH_URL}` : '',
    [PLATFORM_LOCAL_LAUNCH]: '',
})};

const endpointsByEnv = Object.freeze({
    [envNames.DEV]: generateEndpoints('dev.'),
    [envNames.STG]: generateEndpoints('stage.', 'stg.'),
    [envNames.PRE]: generateEndpoints('pre.'),
    [envNames.PROD]: generateEndpoints(''),
});
export const getEndpoint = (name) => endpointsByEnv[runningEnv]?.[name];
